export enum FehmarnDataTabs {
  overview = 0
}

